<template>
  <div class="dialogue" :class="{ collapsed: isCollapsed}"> 
    
    <div class="dialogue-info">

      <BotActionButton class="gray view-toggle icon" @click="toggleView">
        <span v-show="isCollapsed">
          <IconArrowsExpand />
        </span>
        <span v-show="!isCollapsed">
          <IconArrowsCollapse />
        </span>
      </BotActionButton>

      <span class="input-container dialogue-name">
        <BasicInput v-model.trim="dialogue.dialogue_name" v-bind:placeholder="'Name'" class="wide"></BasicInput>
      </span>

      <span class="input-container dialogue-command">
        <BasicInput v-model.trim="dialogue.dialogue_command" v-bind:placeholder="'Command'"></BasicInput>
      </span>

      <BotActionButton class="trash-can icon" @click="deleteDialogue" v-if="dialogue.id !== 0 && dialogue.dialogue_command !== '/start'">
        <Trash />
      </BotActionButton>
    </div>
    <transition name="zoom" mode="out-in">
      <div class="node-container" v-show="!isCollapsed">
        
        <div v-for="(node, index) in dialogue.dialogue_nodes" :key="node.id" class="node-with-arrow">
          <Node :key="node.id" :node="node" :index="index" :nodesCount="dialogue.dialogue_nodes.length" @deleteNode="deleteNode" @moveNodeUp="moveNodeUp" @moveNodeDown="moveNodeDown"></Node>
          <span v-if="index !== dialogue.dialogue_nodes.length - 1" :style="{'text-align': 'center'}">
            <template v-if="typeof node.showNextNode !== 'undefined'" >
              <IconTimer></IconTimer>
              <span :style="{'font-size': '11px'}">{{ formatTime(node.showNextNode) }}</span>
            </template>
            <ArrowRight v-else></ArrowRight>
          </span>
        </div>
        
        <div class="action-buttons">
          <BotActionButton class="gray add-node" @click="addNode" :id="dialogue.id +'_addNode'">
            <IconAddBox />  Add Node 
          </BotActionButton>
        </div>
        
      </div>
    </transition>
    
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Node from '@/components/app/botComponents/Node';
import ArrowRight from '@/components/icons/ArrowRight';
import IconArrowsExpand from '@/components/icons/IconArrowsExpand';
import IconArrowsCollapse from '@/components/icons/IconArrowsCollapse';
import IconAddBox from '@/components/icons/IconAddBox';
import BotActionButton from '@/components/buttons/BotActionButton';
import BasicInput from '@/components/inputs/BasicInput';
import Trash from '@/components/icons/Trash';
import helpers from '@/helpers';
import IconTimer from '@/components/icons/IconTimer'

export default {
  data: () => {
    return {
      collapsed: true
    }
  },
  props: ['dialogue', 'index'],
  computed: {
    isCollapsed() {
      return this.collapsed
    }
  },
  mounted() {},
  methods: {
    addNode: function () {
      const id = helpers.createID();
      this.dialogue.dialogue_nodes.push({
        id: id,
        text: ""
      });
      this.collapsed = false;

      this.$nextTick(() => {
        helpers.scrollElementIntoView(this.dialogue.id + "_addNode", {behavior: "smooth", block: "nearest", inline: "center"});
      })
    },
    deleteNode(index) {
      this.dialogue.dialogue_nodes.splice(index, 1);
    },
    moveNodeUp(index) {
      if (this.dialogue.dialogue_nodes[index-1]) {
        const node = this.dialogue.dialogue_nodes[index];
        this.dialogue.dialogue_nodes[index] = this.dialogue.dialogue_nodes[index-1];
        this.dialogue.dialogue_nodes[index-1] = node;
        this.$forceUpdate();
      } 
    },
    moveNodeDown(index) {
      if (this.dialogue.dialogue_nodes[index+1]) {
        const node = this.dialogue.dialogue_nodes[index];
        this.dialogue.dialogue_nodes[index] = this.dialogue.dialogue_nodes[index+1];
        this.dialogue.dialogue_nodes[index+1] = node;
        this.$forceUpdate();
      } 
    },
    deleteDialogue() {
      this.$emit('deleteDialogue', this.index);
    },
    toggleView() {
      this.collapsed = !this.collapsed
      if (!this.collapsed) {
        this.$nextTick(() => {
          helpers.scrollElementIntoView("dialogue_" + this.index, {behavior: "smooth", inline: "start", block: "end"});
        })
      }
    },
    formatTime(timeInMs){
      if(timeInMs/1000 < 1){
        return `${timeInMs}ms`
      }
      return `${timeInMs/1000}s`
    }
  },
  components: { IconTimer, Node, BasicInput, ArrowRight, BotActionButton, Trash, IconArrowsExpand, IconArrowsCollapse, IconAddBox}
}
</script>

<style lang="scss">
  $textColorLightGray: rgba($color: #fff, $alpha: 0.85);
  $colorOrange: #FBB442;

  .dialogue {
    width: auto;
    height: auto;
    margin: 10px;
    padding: 12px 16px;
    border-radius: 2px;
    border: 1px solid #777777;
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);

    &:hover {
      border-color: $colorOrange;
    }

    &.collapsed {
      border-color: transparent;

      &:hover {
        border-color: #777777;
      }

      .dialogue-info { 
        margin-bottom: 0;
      }
    }

    .dialogue-info {
      width: auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 16px;
      transition: margin-bottom 0.3s cubic-bezier(.25,.8,.25,1);

      .input-container {
        margin: 8px;
      }

      &>span {
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }

    }

    .node-container {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;

      .node-with-arrow {
        display: flex;
        flex-direction: row;
      }

      .action-buttons {
        min-width: 100px;
        padding-top: 40px;
      }
    }

  }

  .add-node {
    width: auto;
    white-space: nowrap;
    svg {
      margin-bottom: -2px;
      margin-right: 8px;
    }
  }
  .icon.view-toggle {
    padding-top: 5px;
    font-size: 1.25em;
  }
  .icon.trash-can {
    background-color: #555555; 
    border: 1px solid rgba($color: #ffffff, $alpha: 0.2);
    color: #9C9C9C;
    padding-bottom: 6px;
    &:hover {
      background-color: #543737;
      border-color: #FF0707;
      color: #FF2C2C;
    }
  }
</style>